import {combineReducers} from 'redux';
import commonsActions from './actions';
import servicesActions from './servicesActions';

export default combineReducers({commonsActions,servicesActions});